import React, { Fragment } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../PrivateRoute';
import HomePage from '../../HomePage/HomePage';
import LoginPage from '../../LoginPage/LoginPage';
import MySnackBar from '../../Common/MySnackBar';
import MyBookings from "../../MyBookings/MyBookings";
import Routine from "../../Routine/Routine";
import AboutPage from "../../AboutPage/AboutPage";
// import SetInstancePage from "../../SetInstancePage/SetInstancePage";
import ListSchedules from "../../Booking/ListSchedules";
import ListTimetables from "../../Booking/ListTimetables";
import ScheduleList from "../../CurrentBookings/ScheduleList";
import LinkAccountReturn from "../../LinkAccount/LinkAccountReturn";

const Content = () => {
    return (
        <Fragment>
            <MySnackBar />
            <PrivateRoute exact path="/" component={HomePage} />
            <PrivateRoute exact path="/my-bookings" component={MyBookings} />
            <PrivateRoute exact path="/bookings/new" component={ListSchedules} />
            <PrivateRoute exact path="/timetables/:schedule_id" component={ListTimetables} />
            <PrivateRoute exact path="/routine" component={Routine} />
            <PrivateRoute exact path="/current-bookings" component={ScheduleList} />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/login" component={LoginPage} />
            {/* Vuelta del Auth Service con #assertion=: fuera del gate para poder cerrar el circuito. */}
            <Route exact path="/vincular" component={LinkAccountReturn} />
        </Fragment>
    );
};

export default Content;
